import { z } from 'zod';

let antiforgery: AntiforgeryResponse | null = null;

const AntiforgeryResponseSchema = z.object({
    expiresAt: z.coerce.date(),
    headerName: z.string(),
    requestToken: z.string()
});

export type AntiforgeryResponse = z.infer<typeof AntiforgeryResponseSchema>;

const getAntiforgeryToken = async (): Promise<AntiforgeryResponse> => {
	try {
		const response: Response = await fetch('/Antiforgery', {
			method: 'GET',
			credentials: 'include',
		});

		if (!response.ok) {
			throw new Error('Failed to fetch antiforgery token');
		}

		const data = await response.json();
		const validated = AntiforgeryResponseSchema.parse(data);
		
		antiforgery = validated;
		
		return validated;
	} catch (error) {
		console.error('Error fetching antiforgery token: ', error);
		throw error;
	}
}

export const ensureAntiforgeryToken = async (): Promise<AntiforgeryResponse> => {
	if (!antiforgery || Date.now() >= antiforgery.expiresAt.getTime()) {
		antiforgery = await getAntiforgeryToken();
	}
	return antiforgery;
}